export function search2D(grid, row, col, word) {
    let R = grid.length;
    let C = grid[0].length;

    let x = [-1, -1, -1, 0, 0, 1, 1, 1];
    let y = [-1, 0, 1, -1, 1, -1, 0, 1];

    if (grid[row][col] !== word[0]) {
        return false;
    }

    let len = word.length;

    for (let dir = 0; dir < 8; dir++) {
        let k;
        let rd = row;
        let cd = col;

        for (k = 0; k < len; k++) {
            if (rd < 0 || rd >= R || cd < 0 || cd >= C) {
                break;
            }

            if (grid[rd][cd] !== word[k]) {
                break;
            }

            rd += x[dir];
            cd += y[dir];
        }

        if (k === len) {
            return true;
        }
    }

    return false;
}

export function patternSearch(grid, word) {
    let R = grid.length;
    let C = grid[0].length;

    let result = [];

    for (let row = 0; row < R; row++) {
        for (let col = 0; col < C; col++) {
            if (search2D(grid, row, col, word.toUpperCase())) {
                let locations = findWordLocations(grid, row, col, word.toUpperCase());
                result = result.concat(locations);
            }
        }
    }

    return result;
}

function findWordLocations(grid, row, col, word) {
    let R = grid.length;
    let C = grid[0].length;

    let x = [-1, -1, -1, 0, 0, 1, 1, 1];
    let y = [-1, 0, 1, -1, 1, -1, 0, 1];

    let len = word.length;

    let locations = [];

    for (let dir = 0; dir < 8; dir++) {
        let k;
        let rd = row;
        let cd = col;

        let wordLocations = [];

        for (k = 0; k < len; k++) {
            if (rd < 0 || rd >= R || cd < 0 || cd >= C) {
                break;
            }

            if (grid[rd][cd] !== word[k]) {
                break;
            }

            wordLocations.push({ row: rd, col: cd, value: grid[rd][cd] });

            rd += x[dir];
            cd += y[dir];
        }

        if (k === len) {
            locations = locations.concat(wordLocations);
        }
    }

    return locations;
}

/**
 * Finds positions of scattered words in the puzzle grid
 * @param {string} filledCoordinates - JSON string containing word coordinates and positions
 * @param {string} word - The word to search for
 * @returns {Array} Array of positions where the word is found, or empty array if not found
 */
export function findScatteredWordPositions(filledCoordinates, word) {
    // Type checking and validation
    if (!filledCoordinates || !word || typeof word !== 'string') {
        return [];
    }
    
    try {
        const coordinates = JSON.parse(filledCoordinates);
        const upperWord = word.toUpperCase();
        
        for (const coord of coordinates) {
            if (coord.text && coord.text.toUpperCase() === upperWord) {
                return coord.positions || [];
            }
        }
    } catch (error) {
        return [];
    }
    
    return [];
}

